export function authErrorMessage(code: string | null | undefined): string {
  switch (code) {
    case "OAuthAccountNotLinked":
      return "This email is already tied to another sign-in method. Use that method, or the same Google account you used before.";
    case "AccessDenied":
      return "This Google account is not allowed to sign in yet. If the app is in Testing, add your Gmail under Test users in Google Cloud.";
    case "OAuthCreateAccount":
    case "OAuthCallback":
    case "OAuthSignin":
    case "Callback":
      return "Google sign-in could not finish. The site database may be missing or not migrated yet on production.";
    case "CredentialsSignin":
      return "Email or password is incorrect.";
    default:
      return "Sign-in failed. Try again, or use email and password.";
  }
}
